import { clientJump } from '@utils';
export const entranceData = {
  shsl: {
    title: '散户数量',
    desc: 'DDE散户数量与股价走势',
    bgClass: 'bg-shsl',
  },
  zlkp: {
    title: '主力控盘比例',
    desc: '查询上市公司主力控盘比例',
    bgClass: 'bg-zlkp',
  },
  zlzj: {
    title: '主力资金流向',
    desc: '今日与历史主力资金流向',
    bgClass: 'bg-zlzj',
  },
  tzbg: {
    title: '投资布局',
    desc: '查询公司的投资布局',
    bgClass: 'bg-tzbg',
  },
};

// 股票class方法
export const getCodeClass = code => {
  let className = '';
  if (code === '17' || code === '33' || code === '145' || code === '151') {
    className = 'default_market';
  } else if (code === '177') {
    className = 'hk_market';
  } else {
    className = 'us_other_market';
  }
  return className;
};

// 跳转详情
export const getStockDetail = (info = {}) => {
  const { id, title, name, type, code, limitType } = info;
  if (type === 'invest') {
    clientJump(
      `${window.location.origin}/yuqingwebapp/yuqingapp/#/stock-toolbox/stock-investment?id=${
        id || ''
      }&title=${title || ''}&name=${name || ''}`,
      0,
      false,
      {
        limitType,
        dataId: id,
      }
    );
  } else if(type === 'jgtc') {
    clientJump(
      `${window.location.origin}/yuqingwebapp/yuqingapp/#/stock-toolbox/institutional-detection?id=${
        id || ''
      }&title=${title || ''}&name=${name || ''}&code=${code}`,
      0,
      false,
      {
        limitType,
        dataId: code,
      }
    )
  } else {
    clientJump(
      `${window.location.origin}/yuqingwebapp/yuqingapp/#/stock-toolbox/investors-detail?id=${
        id || ''
      }&title=${title || ''}&name=${name || ''}&code=${code}`,
      0,
      false,
      {
        limitType,
        dataId: code,
      }
    );
  }
};
